// ============================================================================
// DEMO TEMPLATES SERVICE
// Global catalog of demonstrator starter-repo templates (agentic workflow,
// customer portal, etc.). Listing is open to any authenticated user; every
// mutation requires TEMPLATE_ADMIN (enforced server-side).
// ============================================================================

import { api } from './api';

export interface DemoTemplate {
  templateId: string;
  name: string;
  description: string;
  category: 'agentic-workflow' | 'customer-portal' | 'report' | 'other';
  techStack: string;
  requiredEnvVars: string[];
  active: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDemoTemplateInput {
  name: string;
  description: string;
  category: DemoTemplate['category'];
  techStack: string;
  requiredEnvVars?: string[];
}

export interface DemoTemplateScanFinding {
  file: string;
  pattern: string;
}

export async function listDemoTemplates(category?: string): Promise<DemoTemplate[]> {
  const res = await api.get('/api/demo-templates', { params: category ? { category } : {} });
  return res.data.templates;
}

export async function getDemoTemplate(id: string): Promise<{ template: DemoTemplate; downloadUrl: string | null }> {
  const res = await api.get(`/api/demo-templates/${id}`);
  return res.data;
}

export async function createDemoTemplate(input: CreateDemoTemplateInput): Promise<DemoTemplate> {
  const res = await api.post('/api/demo-templates', input);
  return res.data.template;
}

export async function updateDemoTemplate(id: string, patch: Partial<CreateDemoTemplateInput & { active: boolean }>): Promise<DemoTemplate> {
  const res = await api.put(`/api/demo-templates/${id}`, patch);
  return res.data.template;
}

export async function uploadDemoTemplateZip(id: string, file: File): Promise<DemoTemplate> {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.put(`/api/demo-templates/${id}/zip`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data.template;
}

export async function deleteDemoTemplate(id: string): Promise<void> {
  await api.delete(`/api/demo-templates/${id}`);
}
